import css from 'styled-jsx/css';

const styles = css.global`#canais-atendimento-area-cliente {
    display: none;
}

#canais-atendimento-area-cliente.show {
    display: block;
    background: #FBFBFB;
    position: relative;
}
#canais-atendimento-area-cliente .area-cliente-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    max-width: 702px;
}

#canais-atendimento-area-cliente .area-cliente-btn {
    width: 272px;
    height: 48px;
    margin: 24px auto;
    z-index: 10;
    position: relative;
}

.area-cliente {
    z-index: 1!important;
    position: relative;
}

#canais-atendimento-area-cliente .area-cliente-box-paragrafo {
    color: #444;
    text-align: center;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    width: max-content;
}

#canais-atendimento-area-cliente .area-cliente-boxes {
    display: flex;
    flex-wrap: wrap;
    margin: 48px 0;
    justify-content: center;
    gap: 40px 24px;
}

#canais-atendimento-area-cliente .area-cliente-box {
    width: 132px;
    /* margin-right: 24px; */
    display: flex;
    align-items: center;
    flex-direction: column;
}

#canais-atendimento-area-cliente .area-cliente-box-img {
    width: 40px;
    height: 40px;
}

#canais-atendimento-area-cliente .area-cliente-notebook {
    padding-bottom: 32px;
}

#canais-atendimento-area-cliente .area-cliente-santander-img {
    position: absolute;
    opacity: 0.1;
    left: 0;
    margin-top: -435px;
    z-index: 0;
}

#canais-atendimento-area-cliente .area-cliente-notebook-img {
    position: relative;
    z-index: 9;
}

#canais-atendimento-area-cliente .is-desk {
    display: none;
}

@media(min-width: 992px) {
    #canais-atendimento-area-cliente .is-desk {
        display: flex;
        justify-content: flex-start;
        gap: 48px 88px;
    }

    #canais-atendimento-area-cliente .is-mob {
        display: none;
    }

    #canais-atendimento-area-cliente .area-cliente-content-desk {
        display: flex;
        padding-top: 40px;
    }

    .area-cliente-boxes.is-desk {
        width: 60%;
    }

    .area-cliente-notebook.is-desk {
        width: 40%;
    }

    #canais-atendimento-area-cliente .area-cliente-box {
        width: 170px;
        margin: 0;
    }

    #canais-atendimento-area-cliente .area-cliente-santander-img {
        opacity: 1;
        bottom: 0;
    }

    #canais-atendimento-area-cliente {
        overflow: hidden;
        padding-bottom: 96px;
    }

    #canais-atendimento-area-cliente .area-cliente-notebook-img {
        position: absolute;
        right: 0;
    }

    #canais-atendimento-area-cliente .area-cliente-btn {
        margin: 24px 0 54px;
    }
}

@media(min-width: 992px) and (max-width: 1400px){
    #canais-atendimento-area-cliente .area-cliente-santander-img {
        left: 0;
    }

    #canais-atendimento-area-cliente .area-cliente-notebook-img {
        width: 545px;
    }

    #canais-atendimento-area-cliente {
        padding-bottom: 0px;
    }
}

@media(min-width: 1400px){
    #canais-atendimento-area-cliente .area-cliente-santander-img {
        left: 28%;
    }

    #canais-atendimento-area-cliente .area-cliente-notebook-img {
        width: 628px;
    }

    /* #canais-atendimento-area-cliente {
        padding-bottom: 200px;
    } */
}`;

export default styles;